import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { Box, Card, CardContent, Icon, Stack, Typography } from 'investira.react.components';
import { BaseTemplate } from '../../components/templates';
import { SearchIndicadores } from '../../components/organisms';
import services from '../../services';
import { ROUTES_INDICADORES_TIPO } from '../../enums';

/** Apresenta os tipos disponíveis antes da listagem de indicadores. */
const ListaIndicadores = memo(() => {
  return (
    <BaseTemplate
      title="Lista de Indicadores"
      description="Indicadores econômicos como IPCA, IGP-M, Selic e outros índices importantes para o mercado financeiro."
      searchComponent={<SearchIndicadores dataRead={services.pesquisas.indicador} />}
      maxWidth="xl">
      <Box
        role="list"
        aria-label="Tipos de indicadores disponíveis para consulta"
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
            lg: 'repeat(4, 1fr)'
          },
          gap: 2
        }}>
        {Object.entries(ROUTES_INDICADORES_TIPO).map(([pRoute, pTipo]) => (
          <Link
            key={pTipo.id}
            to={`/indicadores/${pRoute}`}
            aria-label={`Ver indicadores do tipo ${pTipo.descricao}`}>
            <Card sx={{ height: '100%', display: 'flex' }}>
              <CardContent
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  flexGrow: 1,
                  p: 3
                }}>
                <Stack gap="16px">
                  <Icon iconName={pTipo.iconName} color="primary" size={32} />
                  <Stack>
                    <Typography variant="h6" component="h2" color="textPrimary">
                      {pTipo.descricao}
                    </Typography>
                    <Typography variant="caption" color="textPrimary" gutterBottom>
                      {pTipo.metadata.description}
                    </Typography>
                  </Stack>
                </Stack>
              </CardContent>
            </Card>
          </Link>
        ))}
      </Box>
    </BaseTemplate>
  );
});

ListaIndicadores.displayName = 'ListaIndicadores';

export default ListaIndicadores;
